import { object, shape, number, string, objectOf, oneOfType } from 'prop-types';

export default shape({
    pathname: string,
    state: object,
    search: string,
    params: objectOf(oneOfType([string, number])),
});
